import { select, put, takeLatest, call } from 'redux-saga/effects'
import { ClientDataConstants } from '../../../clientData/store/clientData.constants'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../../user/selectors'
import { LabsService } from '../services/labs.service'
import { ILabMetadata, ILabsConfig, ILabsMetadata } from '../store/labs.types'
import { setLabsConfigOptions } from '../../../options/store/options.actions'

export function* setLabsConfig() {
  const serviceId: string = yield select(getServiceIdSelector)
  const labsService = new LabsService(serviceId)
  try {
    const response: { entity: ILabsMetadata } = yield call([labsService, labsService.getLabsConfigDoc])
    const { entity } = response
    entity
      .filter((md) => md.defaultUnits?.includes('</'))
      .map((htmlUnitsMd) => {
        const formattedString: string = htmlUnitsMd.defaultUnits?.replace(/<sup>([^<]+)<\/sup>/g, '^$1')
        htmlUnitsMd.defaultUnits = formattedString || htmlUnitsMd.defaultUnits
      })
    const labsConfig: ILabsConfig = []
    const categoryList = Array.from(new Set(entity.map((item: ILabMetadata) => item.category)))
    categoryList.forEach((category) => {
      if (category !== 'Page 8') {
        const labsMetadata: ILabsMetadata = entity.filter((md) => md.category === category)
        labsConfig.push({ category, labsMetadata })
      }
    })
    yield put(setLabsConfigOptions(labsConfig))
  } catch (e) {
    yield put(throwPcrException(`setLabsConfig() error: ${e}`))
  }
}
export function* setLabsConfigSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setLabsConfig)
}
